import React, { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Meta from 'lib/meta'

import { FilledButton } from 'components/Common/Button'

import styles from './styles.module.css'

export const SpaceNotFound: FC = () => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <>
      <Meta
        title={t('META.TITLE.404_NOT_FOUND_PAGE')}
        description={t('META.DESCRIPTION.404_NOT_FOUND_PAGE')}
        url="https://cloak.ecbo.io"
      />
      <div className={styles.container}>
        <p className={styles.description}>{t('404.SPACE_DETAIL_MESSAGE')}</p>
        <FilledButton cssClassName={{ container: styles.button }} onClick={() => router.push('/')}>
          {t('404.BUTTON_TEXT')}
        </FilledButton>
      </div>
    </>
  )
}
